import { StoreState } from '@/redux/types';

export const selectRatings = (state: StoreState) => state.productTypes.ratings;
